import _throttle from 'lodash/throttle'

export const workListHeight = {
  mounted() {
    this.setWorkListHeight()
    window.addEventListener('resize', this.setWorkListHeight)
  },

  destroyed() {
    window.removeEventListener('resize', this.setWorkListHeight)
  },

  methods: {
    setWorkListHeight: _throttle(function () {
      this.$nextTick(() => {
        if (this.$refs?.workList) {
          const footerHeight = 48
          const el = this.$refs.workList.$el || this.$refs.workList
          const topHeight = el.getBoundingClientRect().top
          el.style.height = window.innerHeight - topHeight - footerHeight + 'px'
        }
      })
    }, 50)
  }
}
